import React from "react"

import Img from "gatsby-image"

import "../hero/hero.css"

const HomepageHero = ({ image }) => (
  <section className="sec-Hero">
    <div className="sec-Hero_Image">
      <Img fluid={image} />
    </div>

    <div className="sec-Hero_Inner lyt-Container">
      <div className="sec-Hero_Body">
        <div className="sec-Hero_Content">
          <div className="sec-Hero_Small">
            <h2 className="sec-Hero_SubTitle">
              CBW Limited
            </h2>
          </div>

          <h1 className="sec-Hero_Title">
            Building and maintenance contractors
          </h1>

          <p className="sec-Hero_Text">CBW Limited provide a fully managed service tailored to your needs.</p>
        </div>
      </div>
    </div>
  </section>
)

export default HomepageHero
